﻿/**
 * Alle Routen der Anwendung an einer Stelle.
 *
 * Seiten, Navigation, Breadcrumbs und Verweise loesen Pfade ausschliesslich
 * hierueber auf - so entstehen keine zwei URLs fuer dasselbe Ziel.
 */
export const paths = {
  dashboard: '/',

  instances: {
    list: '/instanzen',
    detail: (id: string) => `/instanzen/${id}`,
    /** Muster fuer die Routendefinition. */
    detailPattern: '/instanzen/:id',
  },

  plans: '/tarife',
  account: '/konto',
  billing: '/guthaben',
  invoices: '/rechnungen',
  invoiceDetail: (id: string) => `/rechnungen/${id}`,
  invoiceDetailPattern: '/rechnungen/:id',

  admin: {
    servers: '/admin/server',
    ipam: '/admin/ip-verwaltung',
    instances: '/admin/instanzen',
    users: '/admin/benutzer',
    billing: '/admin/guthaben',
    plans: '/admin/tarife',
    mail: '/admin/e-mails',
    settings: '/admin/einstellungen',
    audit: '/admin/protokoll',
  },

  login: '/anmelden',

  /**
   * Oeffentlich erreichbar, auch ohne Sitzung - die Ziele der Links aus
   * Passwort-Reset- und Bestaetigungsmail. Muessen zu den Vorlagen in
   * apps/api/src/lib/mail.ts passen.
   */
  passwordForgot: '/passwort-vergessen',
  passwordReset: '/passwort-neu',
  verifyEmail: '/bestaetigen',
} as const;
